var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M24.5 23v-2a4.002 4.002 0 0 0-3-3.874M18 5.291a4.001 4.001 0 0 1 0 7.418M19.5 23c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.165C16.296 17 15.364 17 13.5 17h-3c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C4.5 20.204 4.5 21.136 4.5 23M16 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.d888c9f30e2bfc294c79677c49063096.svg";
export { ForwardRef as ReactComponent };